import { render, staticRenderFns } from "./ButtonOptions.vue?vue&type=template&id=5a47d1dc"
import script from "./ButtonOptions.vue?vue&type=script&lang=js"
export * from "./ButtonOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports